import Tooltip from "rc-tooltip";
import React, { FC, useState } from "react";
import { Icon, Menu } from "semantic-ui-react";
import HeatmapExportModal from "./index";
import { useUserAuth } from "../../../hooks/useUserAuth";
import { ApplicationArea } from "../../Lumber/ApplicationAreas";

type Props = {
	id: string;
	type: "Trial" | "Field" | "Protocol";
};

const HeatmapExportModalMenuIcon: FC<Props> = ({ id, type }) => {
	const [open, setOpen] = useState(false);
	const userAuth = useUserAuth();

	return (
		<>
			<Tooltip
				placement="right"
				align={{ offset: [-8, 0] }}
				mouseEnterDelay={0}
				mouseLeaveDelay={0}
				trigger="hover"
				overlay="Export Data"
				transitionName="rc-tooltip-zoom"
			>
				<Menu.Item
					key={"dataExportModal"}
					className={!id ? "disabledNavItem" : undefined}
					active={open}
					onClick={() => {
						if (
							id &&
							((type == "Field" &&
								userAuth.hasApplicationArea(ApplicationArea.FieldExportFunctionality, userAuth.currentClientId)) ||
								((type == "Trial" || type == "Protocol") &&
									userAuth.hasApplicationArea(ApplicationArea.TrialExportFunctionality, userAuth.currentClientId)))
						)
							setOpen((prev) => !prev);
					}}
				>
					<Icon className="download" size="large" style={{ margin: "0px" }} />
				</Menu.Item>
			</Tooltip>
			<HeatmapExportModal id={id} open={open} setOpen={setOpen} type={type} />
		</>
	);
};

export default HeatmapExportModalMenuIcon;
